import { render, staticRenderFns } from "./oldPlan.vue?vue&type=template&id=dd72d1b4&scoped=true"
import script from "./oldPlan.vue?vue&type=script&lang=js"
export * from "./oldPlan.vue?vue&type=script&lang=js"
import style0 from "./oldPlan.vue?vue&type=style&index=0&id=dd72d1b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd72d1b4",
  null
  
)

export default component.exports